<template>
    <section class="fin-space-y-4">
        <el-form ref="emailRecipients" label-width="140px">
            <el-form-item label="From">
                <el-select
                    class="fin-w-full"
                    v-model="from"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="Select/Create from email">
                    <el-option
                        v-for="(item, key) in fromEmailOptions"
                        :key="key"
                        :label="item.email"
                        :value="item.email"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="To">
                <el-select
                    class="fin-w-full"
                    v-model="to"
                    multiple
                    filterable
                    remote
                    allow-create
                    default-first-option
                    :remote-method="remoteMethod"
                    placeholder="Select/Create to email">
                    <el-option
                        v-for="(item, key) in toEmailOptions"
                        :key="key"
                        :label="item.email"
                        :value="item.id"
                    >
                        <div class="fin-flex fin-justify-between">
                            <p class="fin-text-left fin-break-words w-50">{{
                                    item.first_name + " " + item.last_name
                                }}</p>
                            <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{ item.email }}</p>
                            <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{ item.state }}</p>
                            <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{
                                    _.get(item, 'lender.name', _.get(item, 'company'))
                                }}</p>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="CCs">
                        <el-select
                            class="fin-w-full"
                            v-model="ccs"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            :remote-method="remoteMethod"
                            placeholder="Select/Create ccs email">
                            <el-option
                                v-for="(item, key) in ccsEmailOptions"
                                :key="key"
                                :label="item.email"
                                :value="item.email"
                            >
                                <div class="fin-flex fin-justify-between">
                                    <p class="fin-text-left fin-break-words w-50">
                                        {{ item.first_name + " " + item.last_name }}</p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{
                                            item.email
                                        }}</p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{
                                            item.state
                                        }}</p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">{{
                                            _.get(item, 'lender.name', _.get(item, 'company'))
                                        }}</p>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="BCCs">
                        <el-select
                            class="fin-w-full"
                            v-model="bccs"
                            multiple
                            filterable
                            allow-create
                            :remote-method="remoteMethod"
                            default-first-option
                            placeholder="Select/Create bccs email">
                            <el-option
                                v-for="(item, key) in bccsEmailOptions"
                                :key="key"
                                :label="item.email"
                                :value="item.email"
                            >
                                <div class="fin-flex fin-justify-between">
                                    <p class="fin-text-left fin-break-words w-50">
                                        {{ item.first_name + " " + item.last_name }}
                                    </p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">
                                        {{ item.email }}
                                    </p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">
                                        {{ item.state }}
                                    </p>
                                    <p class="fin-font-semibold fin-text-right fin-break-words w-50">
                                        {{
                                            _.get(item, 'lender.name', _.get(item, 'company'))
                                        }}
                                    </p>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </section>
</template>

<script>
export default {
    name: 'EmailRecipients',
    props: {
        fromEmailOptions: {
            type: [Array],
            default: function () {
                return []
            },
            required: false
        },
        toEmailOptions: {
            type: [Array],
            default: function () {
                return []
            },
            required: false
        },
        ccsEmailOptions: {
            type: [Array],
            default: function () {
                return []
            },
            required: false
        },
        bccsEmailOptions: {
            type: [Array],
            default: function () {
                return []
            },
            required: false
        },
        isApi: {
            required: true,
        }
    },
    data() {
        return {
            from: '',
            to: [],
            ccs: [],
            bccs: [],
            searchTimeout: 1000,
            toDirectories: []
        }
    },
    computed: {},
    watch: {
        'from': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.$store.dispatch("ticketEmail/setFromEmail", val)
                }, this.searchTimeoutWait)
            },
            immediate: true
        },
        'to': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    let selectedTo = []

                    if (_.size(val)) {
                        val.map(toEmail => {
                            if (_.isString(toEmail)) {
                                selectedTo.push(toEmail)
                            } else {
                                const findToMail = _.find(this.toDirectories, {id: toEmail})
                                if (findToMail) {
                                    selectedTo.push(findToMail)
                                }
                            }
                        })
                    }

                    this.$store.dispatch("ticketEmail/setToEmails", selectedTo)
                }, this.searchTimeoutWait)
            },
            immediate: true
        },
        'ccs': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    let selectedTo = []

                    if (_.size(val)) {
                        val.map(toEmail => {
                            if (_.isString(toEmail)) {
                                selectedTo.push(toEmail)
                            } else {
                                const findToMail = _.find(this.toDirectories, {id: toEmail})
                                if (findToMail) {
                                    selectedTo.push(findToMail)
                                }
                            }
                        })
                    }

                    this.$store.dispatch("ticketEmail/setCCEmails", selectedTo)
                }, this.searchTimeoutWait)
            },
            immediate: true
        },
        'bccs': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    let selectedTo = []

                    if (_.size(val)) {
                        val.map(toEmail => {
                            if (_.isString(toEmail)) {
                                selectedTo.push(toEmail)
                            } else {
                                const findToMail = _.find(this.toDirectories, {id: toEmail})
                                if (findToMail) {
                                    selectedTo.push(findToMail)
                                }
                            }
                        })
                    }

                    this.$store.dispatch("ticketEmail/setBCCsEmails", selectedTo)
                }, this.searchTimeoutWait)
            },
            immediate: true
        },
    },
    mounted() {
        this.getDirectories()
    },
    methods: {
        remoteMethod(query) {
            if (query !== "") {
                setTimeout(() => {
                    this.$bus.$emit('remote-fetch-toEmailOptions', query)
                }, 200)
            } else {
                this.$bus.$emit('remote-fetch-toEmailOptions', '')
            }
        },
        getDirectories() {
            this.$admin.get('/api/lender_tenant_directories/get-directories').then(res => {
                this.toDirectories = res.data
            })
        }
    }
}
</script>
